export default {
  dashboardMenu: "User Menu",
  orders: "Orders",
  addresses: "Addresses",
  accountInfo: "Account Info",
  logout: "Log Out",
  urls: {
    Order:"/en/dashboard/Order",
    Address:"/en/dashboard/address",
    Profile:"/en/dashboard/profile",
  }
};
